// Main Casino.js - Migrated to use Arrays instead of Objects
import React, { useState, useEffect } from "react";
import CasinoHeader from "./components/CasinoHeader";
import CasinoSidebar from "./components/CasinoSidebar";
import GamesGrid from "./components/GamesGrid";
import BetSlip from "./components/BetSlip";
import MobileBetSlip from "./components/MobileBetSlip";
// import { GameModal } from "./GameModal";
import {
  getAvailableDimensions,
  importGameImages,
  importLivePragmaticGameImages,
  PROVIDERS,
  setSelectedProviderHandler,
  topGamesArray,
} from "../../utils";
import { GameModes } from "../../config";
import { config } from "../../config";
import {
  useCategoryGamesMutation,
  useGetEuroVirtualGamesQuery,
} from "../../store/apis";
import Winners from "./components/Winners";
import MobileLeftPart from "./components/MobileLeftPart";
import { useLocation } from "react-router-dom";
import { useTheme } from "../../context/ThemeContext";
import BottomNavigation from "../../Components/BottonNavigation";

const Casino = () => {
  // Core state - Now using arrays instead of objects
  const location = useLocation();
  const { isDarkMode } = useTheme();
  const [selectedGame, setSelectedGame] = useState("");
  const [games, setGames] = useState([]);
  const [filteredGames, setFilteredGames] = useState([]);
  const [selectedProvider, setSelectedProvider] = useState(null);
  const [dimensions, setDimensions] = useState([]);
  const [selectedDimension, setSelectedDimension] = useState("167-117");
  const [virtualGames, setVirtualGames] = useState([]);

  // Game category state
  const [activeCategory, setActiveCategory] = useState("All");
  const { data, isLoading } = useGetEuroVirtualGamesQuery();
  const [allProviderGames, setAllProviderGames] = useState([]);
  const [livePragmaticGames, setLivePragmaticGames] = useState([]);
  const [isProviderChangeLoading, setIsProviderChangeLoading] = useState();
  const [categoryGames, setCategoryGames] = useState([]);

  // Mobile betslip state
  const [isBetSlipOpen, setIsBetSlipOpen] = useState(false);
  const [isLoadingAllGames, setIsLoadingAllGames] = useState(false);
  const [
    getGamesCategory,
    { isLoading: isGetGamesCategoryIsloading, isError },
  ] = useCategoryGamesMutation();

  useEffect(() => {
    if (data && data.data) {
      setVirtualGames(data.data.data);
    }
  }, [data]);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const category = queryParams.get("category");
    const provider = queryParams.get("provider");

    if (category) {
      setActiveCategory(category);
      setSelectedProvider(null);
    }
    if (provider) {
      const providerItem = setSelectedProviderHandler(provider);
      setSelectedProvider(providerItem);
      setActiveCategory(null);
      console.log("😎😎😋", providerItem);
    }
  }, [location.search]);
  useEffect(() => {
    console.log("😎😎😋", selectedProvider);
  }, []);

  useEffect(() => {
    const fetchLivePragmaticGames = async () => {
      const liveGames = await importLivePragmaticGameImages();
      setLivePragmaticGames(liveGames);
    };
    fetchLivePragmaticGames();
  }, []);

  // Helper function to convert object to array with key as id
  const objectToArray = (gameObject) => {
    return Object.entries(gameObject).map(([key, value]) => ({
      ...value,
      id: key,
      key: key, // Keep key for backward compatibility
    }));
  };

  // Helper function to convert topGamesData object to array
  const getTopGamesArray = () => {
    return objectToArray(topGamesArray);
  };

  // Helper function to ensure top games are always first
  const ensureTopGamesFirst = (gameArray) => {
    const topGamesArray = getTopGamesArray();
    const topGameIds = new Set(topGamesArray.map((game) => game.id));
    const topGameNames = new Set(
      topGamesArray.map((game) => game.name?.toLowerCase()).filter(Boolean)
    );

    // Mark games as top or not
    const markedGames = gameArray.map((game) => {
      const gameName = (game.name || game.gameName || "").toLowerCase();
      const isTopGame =
        topGameIds.has(game.id) ||
        topGameIds.has(game.key) ||
        topGameNames.has(gameName);
      return { ...game, isTopGame };
    });

    // Sort: top games first, then regular games
    markedGames.sort((a, b) => {
      if (a.isTopGame === b.isTopGame) {
        return 0; // keep original relative order if both same group
      }
      return a.isTopGame ? -1 : 1; // top games come first
    });

    // Add any missing top games at the beginning
    const existingGameIds = new Set(
      markedGames.map((game) => game.id || game.key)
    );
    const missingTopGames = topGamesArray.filter(
      (topGame) =>
        !existingGameIds.has(topGame.id) && !existingGameIds.has(topGame.key)
    );

    return [
      ...missingTopGames.map((game) => ({ ...game, isTopGame: true })),
      ...markedGames,
    ];
  };
  // Add this new effect to handle provider-based filtering
  useEffect(() => {
    const loadProviderGames = async () => {
      if (selectedProvider && !activeCategory) {
        // Only filter by provider if no active category is set
        setIsProviderChangeLoading(true);
        try {
          const gameImagesObject = await importGameImages(
            selectedProvider.folderName,
            selectedDimension
          );
          // Convert to array
          const gameImagesArray = objectToArray(gameImagesObject);

          // Ensure top games are first for provider-specific view
          const sortedGames = ensureTopGamesFirst(gameImagesArray);
          setGames(sortedGames);
        } catch (error) {
          console.log("error loading provider games:", error);
        } finally {
          setIsProviderChangeLoading(false);
        }
      }
    };

    loadProviderGames();
  }, [selectedProvider, selectedDimension, activeCategory]);
  // Effect for initial provider setup and loading all games
  useEffect(() => {
    // Set initial provider
    // const initialProvider = Object.values(PROVIDERS)[0];
    // setSelectedProvider(initialProvider);

    // Load all games from all providers
    const loadAllGames = async () => {
      setIsLoadingAllGames(true);
      try {
        let tempAllGames = [];

        // 1. First add all top games
        tempAllGames = [...getTopGamesArray()];

        // 2. Then load games from each provider
        // Helper function to check if a game is in top games
        const isGameInTopGames = (game, topGames) => {
          return topGames.some(
            (topGame) =>
              topGame.id === game.id ||
              topGame.key === game.key ||
              (topGame.name &&
                game.name &&
                topGame.name.toLowerCase() === game.name.toLowerCase())
          );
        };

        for (const provider of Object.values(PROVIDERS)) {
          const providerGamesObject = await importGameImages(
            provider.folderName,
            selectedDimension
          );

          // Convert to array
          const providerGamesArray = objectToArray(providerGamesObject);

          // Capture the current value of tempAllGames to avoid unsafe closure
          const currentTempAllGames = tempAllGames;

          // Filter out games that are already in top games
          const filteredProviderGames = providerGamesArray.filter((game) => {
            return !isGameInTopGames(game, currentTempAllGames);
          });

          tempAllGames = [...tempAllGames, ...filteredProviderGames];
        }

        setAllProviderGames(tempAllGames);
      } catch (error) {
        console.error("Error loading all games:", error);
      } finally {
        setIsLoadingAllGames(false);
      }
    };

    loadAllGames();
  }, [selectedDimension]);

  // Effect for loading games when provider or dimension changes
  useEffect(() => {
    const loadGames = async () => {
      setIsProviderChangeLoading(true);
      try {
        if (selectedProvider) {
          const gameImagesObject = await importGameImages(
            selectedProvider.folderName,
            selectedDimension
          );
          // Convert to array
          const gameImagesArray = objectToArray(gameImagesObject);
          setGames(gameImagesArray);
        }
      } catch (error) {
        console.log("error loading games:", error);
      } finally {
        setIsProviderChangeLoading(false);
      }
    };

    loadGames();
  }, [selectedProvider, selectedDimension]);

  // Effect to filter games when activeCategory changes
  useEffect(() => {
    const fetchCategoryGames = async () => {
      if (
        activeCategory !== "All" &&
        activeCategory !== "Top" &&
        activeCategory !== "Virtuals" &&
        activeCategory !== "PragmaticLive" &&
        activeCategory !== "regular"
      ) {
        try {
          // Call the API to get games for the selected category
          const response = await getGamesCategory({ category: activeCategory });
          if (response.data) {
            setCategoryGames(response);

            // Filter all provider games based on the category games
            const categoryGameNames = response.data.map(
              (game) => game.game_name
            );
            console.log("Category game names", categoryGameNames);

            // Filter games from allProviderGames based on category game names
            const filtered = allProviderGames.filter((game) => {
              const nameToCheck = game.name || game.id || game.key;
              return categoryGameNames.includes(nameToCheck);
            });

            setFilteredGames(filtered);
          }
        } catch (error) {
          console.error("Error fetching category games:", error);
        }
      }
    };

    fetchCategoryGames();
  }, [activeCategory, getGamesCategory, allProviderGames]);

  const handleGameClick = (gameId) => {
    setSelectedGame(gameId);
  };

  const formatVirtualGames = () => {
    return virtualGames.map((game) => ({
      id: game.game_uuid,
      key: game.game_uuid,
      imagePath: game.thumbnail,
      provider: "eurovirtual",
      gameName: game.game_name,
      name: game.game_name,
      isVirtual: true,
      currency: game.currency,
      minStake: JSON.parse(game.minimum_stake),
      maxStake: JSON.parse(game.maximum_stake),
      maxWin: JSON.parse(game.maximum_win),
      denominations: game.denomination,
    }));
  };

  const handleCategoryChange = (categoryName) => {
    setActiveCategory(categoryName);
  };

  // Helper function to filter out top games from other game collections
  const filterOutTopGames = (gameArray) => {
    const topGamesArray = getTopGamesArray();
    const topGameIds = new Set(topGamesArray.map((game) => game.id));
    const topGameNames = new Set(
      topGamesArray.map((game) => game.name?.toLowerCase()).filter(Boolean)
    );

    return gameArray.filter((game) => {
      const isTopGame =
        topGameIds.has(game.id) ||
        topGameIds.has(game.key) ||
        topGameNames.has((game.name || game.gameName || "").toLowerCase());
      return !isTopGame;
    });
  };

  // Helper function to combine games with top games first
  const combineGamesWithTopFirst = (otherGames) => {
    const topGamesArray = getTopGamesArray();
    const filteredOtherGames = filterOutTopGames(otherGames);
    return [...topGamesArray, ...filteredOtherGames];
  };

  // Modified to handle the specific game categories
  const getDisplayGames = () => {
    if (selectedProvider && !activeCategory) {
      return games;
    }
    if (activeCategory === "Virtuals") {
      return formatVirtualGames();
    } else if (activeCategory === "All") {
      // Start with allProviderGames which already has top games first
      let combinedGames = [...allProviderGames];

      // Include virtual games in "All" category
      if (virtualGames.length > 0) {
        const formattedVirtualGames = formatVirtualGames();
        const filteredVirtualGames = filterOutTopGames(formattedVirtualGames);
        combinedGames = [...combinedGames, ...filteredVirtualGames];
      }

      const sortedGames = ensureTopGamesFirst(combinedGames);

      return sortedGames;
    } else if (activeCategory === "Top") {
      return getTopGamesArray();
    } else if (activeCategory === "PragmaticLive") {
      return livePragmaticGames;
    } else if (
      ["Crash", "Lite", "Drops and …", "Slots", "Table/Cards"].includes(
        activeCategory
      )
    ) {
      // Return top games first, then filtered games for specific categories
      // return combineGamesWithTopFirst(filteredGames);
      return filteredGames;
    }
    return games;
    // For other categories or specific provider selection, also start with top games
    // const filteredProviderGames = filterOutTopGames(games);
    // return [...getTopGamesArray(), ...filteredProviderGames];
  };

  const getTitle = () => {
    if (activeCategory) {
      return activeCategory;
    } else if (selectedProvider?.folderName) {
      return selectedProvider.folderName;
    } else {
      return "All games";
    }
  };

  return (
    <>
      <div className="relative bg-[#F2F4F6] dark:bg-darkblue pb-[70px] s15:pb-[100px]">
        <div className="w-full max-w-[1760px] md:px-5 mx-auto">
          <div className="grid grid-cols-12 gap-5 md:gap-3 s18:gap-5">
            {/* Sidebar with categories and providers */}
            <div className="max-md:hidden md:col-span-3 s15:col-span-2">
              <CasinoSidebar
                selectedProvider={selectedProvider}
                setSelectedProvider={(provider) => {
                  setSelectedProvider(provider);
                }}
                activeCategory={activeCategory}
                onCategoryChange={handleCategoryChange}
              />
            </div>

            {/* Main content area */}
            <div className="col-span-12 md:col-span-9 s15:col-span-10">
              <div className="flex flex-col gap-[10px]">
                <CasinoHeader />
                <>
                  <Winners />
                </>
                <MobileLeftPart
                  selectedProvider={selectedProvider}
                  setSelectedProvider={(provider) => {
                    setSelectedProvider(provider);
                  }}
                  activeCategory={activeCategory}
                  onCategoryChange={handleCategoryChange}
                />
                <GamesGrid
                  games={getDisplayGames()}
                  onGameClick={handleGameClick}
                  isVirtual={activeCategory === "Virtuals"}
                  isLoading={
                    isLoading ||
                    isLoadingAllGames ||
                    isGetGamesCategoryIsloading ||
                    isProviderChangeLoading
                  }
                  title={getTitle()}
                />
              </div>
            </div>

            <BottomNavigation showBetslip={false} />
          </div>
        </div>
      </div>

      {/* Game modal */}
      {/* {selectedProvider && selectedGame && (
        <GameModal
          isOpen={!!selectedGame}
          onClose={() => setSelectedGame(null)}
          gameAlias={selectedGame}
          mode={gameMode}
          currency={currency}
          gameProvider={selectedProvider.id}
          lang={lang}
          sessionId={null}
        />
      )} */}
    </>
  );
};

export default Casino;
